import React from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";

function SiteAction({
  children,
  className = "",
  external = false,
  href,
  to,
  ...rest
}) {
  const resolvedClassName = classnames("site-btn", className);
  const resolvedHref = href || to;
  const isMailto = typeof resolvedHref === "string" && resolvedHref.startsWith("mailto:");

  if (!external && to) {
    return (
      <Link className={resolvedClassName} to={to} {...rest}>
        {children}
      </Link>
    );
  }

  return (
    <a
      className={resolvedClassName}
      href={resolvedHref}
      rel={isMailto ? undefined : "noopener noreferrer"}
      target={isMailto ? undefined : "_blank"}
      {...rest}
    >
      {children}
    </a>
  );
}

export default SiteAction;
